import { Component, HostBinding, OnInit, ViewChild } from "@angular/core";
import { FieldConfig } from "../../field.interface";
@Component({
  selector: "app-separador",
  template: `
        <div class="row">
            <div class="col-12">
                <div class="h6 text-dark">
                    {{field.label}}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
            <hr class="mt-0 border-dark">
            </div>
        </div>
`,
  styles: []
})
export class SeparadorComponent implements OnInit {
  field: FieldConfig;
  @HostBinding('class') class = '';
  constructor() {
  }
  ngOnInit() {
    this.class = this.field.claseGrillaBootstrap;
  }
}
